<div class="w-full overflow-y-auto min-w-9 flex flex-col " cdkScrollable>
    <div *ngIf="FiltersLikes&&FiltersLikes.length>0" class="flex justify-center smm:mb-2">
         <mat-form-field class="fuse-mat-dense fuse-mat-no-subscript fuse-mat-rounded min-w-64">
            <mat-icon class="icon-size-5" matPrefix svgIcon="heroicons_solid:search">
            </mat-icon>
            <input matInput placeholder="Buscar" autocomplete="off" #buscar (keyup)="filters(buscar.value)" />
        </mat-form-field>
        <button *ngIf="filterComponent" #filtro class="ml-2 bg-primary dark:text-white " mat-button type="button" (click)="modalUp(filtro)">
            <mat-icon svgIcon="heroicons_outline:adjustments"></mat-icon>
        </button>
    </div>
    <table mat-table [dataSource]="dataSource" class="w-full overflow-hidden smm:px-0 smm:mt-0 px-4 mt-4" matSort>
        <ng-container [matColumnDef]="column" *ngFor="let column of columnsParams; let i = index">
            <th mat-header-cell *matHeaderCellDef mat-sort-header class="px-3 "> {{ columnsNames[i] }} </th>
            <td mat-cell *matCellDef="let element" class="px-3" (click)="toggleExpand(element[column])" class="descripcion-container">
                <p class="mobile-label">{{ columnsNames[i]  }}</p> 
                <p [@panelState]="isExpanded(element[column])" class="descripcion px-3">{{ element[column] }}</p>
            </td>
        </ng-container>

        <!-- <ng-template #botones>
            <th mat-header-cell *matHeaderCellDef> {{ columnsNames[i] }}</th>
            <td mat-cell *matcellDef="let element"> 
COMENTARIO                Element es el objeto iterado desde el dataSource
                <div style="display: block ruby;">
                    <button mat-raised-button color="accent" *ngFor="let accion of functions; let x = index" (click)="emitFunction(accion.functionName, element)" class="mx-0.5" matTooltip="{{accion.nombre_boton}}" matTooltipPosition="above" matTooltipClass="tooltip-class" ToptipTouchGestures="auto">
                        <mat-icon *ngIf="!!accion.icono" svgIcon="{{accion.icono}}"></mat-icon>
                    </button>
                </div>
            </td>
        </ng-template> -->
        
        <tr mat-header-row *matHeaderRowDef="columnsParams"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsParams;"></tr>
    </table>

    <div *ngIf="(this.dataSource.data.length == 0)" style="text-align: center;">
        <br>
            <h3>Sin datos historicos.</h3>
        <br>
    </div>
    <mat-paginator [pageSizeOptions]="pageSizeOptions" class="rounded-b-lg shadow-md" [pageSize]="pageSize" aria-label="Select page" (page)="cambioPagina($event)"> </mat-paginator>
</div>